import * as React from "react";
import i18n from "i18n";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import NumberFormat from "react-number-format";
import { WBSStore } from "modules/WBS/WBSStore";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  withStyles,
  Tooltip,
  Button,
} from "@material-ui/core";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import { WBSPropertiesStore } from "modules/WBS/WBSPropertiesStore";
import { List } from "react-virtualized";
import { EContentType } from "common/enums";
import { IResourceToUpdate } from "common/interfaces";
import { roundBy, times } from "utils/DecimalUtils";

const COLUMN_SIZE = [
  100, // rowCode
  220, // description
  90, // unit
  110, // unitCost
  110, // newCost
  100, // contentType
];

const columnWidthConst = ((window.innerWidth - 290) * 100) / 730 / 100;
const styles = (theme) => ({
  overflow: {
    overflow: "auto",
    height: "calc(100vh - 241px)",
  },
  table: {
    fontFamily: "Roboto",
  },
  editFormatActions: {
    display: "flex",
    justifyContent: "center",
  },
  tableHead: {
    fontSize: "12px",
    color: "#5c5c5c",
    "& th": {
      padding: "15px",
      border: "0px",
    },
  },
  button: {
    height: "36px",
    marginBottom: 50,
    marginTop: 36,
    marginLeft: 8,
    marginRight: 8,
  },
  buttonSave: {
    width: "84px",
    background: "#ABC200",
    "&:hover": {
      background: "#92A501",
    },
  },
  buttonCancel: {
    width: "102px",
    background: "#ABABAB",
    "&:hover": {
      background: "#8f8f8f",
    },
  },
  relative: {
    position: "relative" as any,
  },
  rowRoot: {
    height: "50px",
    "& > :last-child": {
      padding: "0px",
      borderRight: "0",
    },
  },
  cellWrapper: {
    cursor: "pointer",
    transition: "all 0.3s ease-in",
    "&:hover": {
      backgroundColor: "#EDF2CB",
      "& > img": {
        opacity: 1,
      },
    },
    position: "sticky" as any,
    top: "0px",
    background: "white",
    zIndex: 10 as any,
  },
  input: {
    outlineStyle: "none" as any,
    paddingRight: "10px",
    paddingLeft: "10px",
    color: "#666",
    height: "24px",
    width: "100%",
    border: "0",
    backgroundColor: "unset",
    fontSize: "13px",
  },
  noPadding: {
    padding: "0px !important",
    width: 200,
    borderRight: "1px solid #e0e0e0",
  },

  hover: {
    "&:hover": {
      backgroundColor: "#FAFAFA",
    },
  },
});

type IProps = {
  classes: any;
  treeReference: Boolean;
};

@observer
class UpdateBudgetResorcesTab2 extends React.Component<IProps> {
  state = {
    currentClmn: "",
    inputValue: "" as string | number,
    numericInputValue: -1,
    // allResources: [] as any,
    selectedLine: -1,
    resourcesDataTable: [] as any,
    loading: undefined,
    needUpdate: false,
    orderBy: "",
    orderByDirection: "desc",
  };

  constructor(props) {
    super(props);
  }

  handleClickSave = async () => {
    TakeOffStore.takeOffLoading = true;
    let toUpdate: IResourceToUpdate[] = [];
    for (let i = 0; i < WBSStore.newCompositionList.length; i++) {
      const element = WBSStore.newCompositionList[i];
      let rateLibraryId = element.new.data.file.id;
      let rateLibraryCode = element.new.data.code;
      let rateLibraryName = element.new.data.description;

      for (let j = 0; j < element.old.allId.length; j++) {
        let rowIndex = WBSStore.WBSRows.findIndex(
          (rows) => rows.id == element.old.allId[j]
        );
        let row: any = WBSStore.WBSRows[rowIndex];
        if (row) {
          row.data.unitCost = element.new.data.totalCost;
          row.data.total = times(
            element.new.data.totalCost,
            row.data.quantity,
            WBSPropertiesStore.getRules(2)
          );
        }
        toUpdate.push({
          id: element.old.allId[j],
          totalCost: element.new.data.totalCost,
          unitCost: element.old.data.unitCost,
          quantity: element.old.data.quantity,
          parentTask: element.old.data.parentTask,
          contentId: element.old.data.contentId,
          rateLibraryId: rateLibraryId,
          rateLibraryCode,
          rateLibraryName,
        });
      }
    }

    await WBSStore.updateRateLibrariesResources(toUpdate);
    WBSStore.newCompositionList = [];
    WBSStore.selectedComposition = {};
    TakeOffStore.swipeTabComposition = 0;
    TakeOffStore.takeOffLoading = false;
  };

  ordemItem(valueToCompare, value) {
    const item = valueToCompare.old.data;
    let result: any = "";
    switch (value) {
      case "rowCode":
        result = valueToCompare.new.data.code;
        break;
      case "description":
        result = item.description;
        break;
      case "unit":
        result = item.unit;
        break;
      case "unitCost":
        result = item.unitCost;
        break;
      case "newCost":
        result = valueToCompare.new.data.totalCost;
        break;
      case "contentType":
        result = item.contentType;
        break;
      default:
        break;
    }
    return result;
  }

  orderComponentsBy(list, value) {
    let listTmp = toJS(list);
    if (
      this.state.orderBy === value &&
      this.state.orderByDirection === "desc"
    ) {
      this.setState({ orderByDirection: "asc" });
      listTmp.sort((a, b) => {
        let aResult = this.ordemItem(a, value);
        let bResult = this.ordemItem(b, value);
        let c =
          aResult != undefined && isNaN(aResult)
            ? aResult.toUpperCase()
            : aResult;
        let d =
          bResult != undefined && isNaN(bResult)
            ? bResult.toUpperCase()
            : bResult;
        return c < d ? -1 : c > d ? 1 : 0;
      });
    } else {
      this.setState({ orderBy: value, orderByDirection: "desc" });
      listTmp.sort((a, b) => {
        let aResult = this.ordemItem(a, value);
        let bResult = this.ordemItem(b, value);

        let c =
          aResult != undefined && isNaN(aResult)
            ? aResult.toUpperCase()
            : aResult;
        let d =
          bResult != undefined && isNaN(bResult)
            ? bResult.toUpperCase()
            : bResult;
        return c < d ? 1 : c > d ? -1 : 0;
      });
    }
    return listTmp;
  }

  headerRenderer = ({
    key, // Unique key within array of rows
    style, // Style object to be applied to row (to position it)
  }) => {
    const { classes } = this.props,
      rowClasses = { root: classes.rowRoot };

    const tableCell = (index_name, name, width) => {
      let tAlign = index_name === "description" ? "left" : "center";
      let padding = index_name === "description" ? 15 : 0;
      return (
        <Tooltip title={name}>
          <TableCell
            className={classes.cellWrapper}
            key={`header_${name}`}
            style={{
              textAlign: tAlign as any,
              width,
              padding,
              fontWeight: index_name === "newCost" ? "bold" : "normal",
            }}
            onClick={() => {
              let orderedResources = this.orderComponentsBy(
                WBSStore.newCompositionList,
                index_name
              );
              WBSStore.newCompositionList = orderedResources;
            }}
          >
            <div style={{ textAlign: tAlign as any }}>
              {name}
              {this.state.orderBy === index_name &&
                (this.state.orderByDirection === "asc" ? (
                  <KeyboardArrowUp
                    style={{
                      height: 15,
                      width: 15,
                      marginLeft: 2,
                      verticalAlign: "top",
                    }}
                  ></KeyboardArrowUp>
                ) : (
                  <KeyboardArrowDown
                    style={{
                      height: 15,
                      width: 15,
                      marginLeft: 2,
                      verticalAlign: "top",
                    }}
                  ></KeyboardArrowDown>
                ))}
            </div>
          </TableCell>
        </Tooltip>
      );
    };
    return (
      <Table key={key} style={style} className={classes.table}>
        <TableHead className={classes.tableHead}>
          <TableRow classes={rowClasses}>
            {tableCell(
              "rowCode",
              i18n.project.rightSideMenu.code,
              COLUMN_SIZE[0]
            )}
            {tableCell(
              "description",
              i18n.resources.description,
              COLUMN_SIZE[1]
            )}
            {tableCell("unit", i18n.resources.unity, COLUMN_SIZE[3])}
            {tableCell("unitCost", i18n.resources.unitCost, COLUMN_SIZE[4])}
            {tableCell("newCost", i18n.resources.newCost, COLUMN_SIZE[4])}
            {tableCell(
              "contentType",
              i18n.resources.classification,
              COLUMN_SIZE[5]
            )}
          </TableRow>
        </TableHead>
      </Table>
    );
  };
  columnWidth(width) {
    return width * columnWidthConst;
  }

  cellRenderer = ({
    key, // Unique key within array of rows
    style, // Style object to be applied to row (to position it)
    index, // Index of row
  }) => {
    const { classes } = this.props;
    const tableCell = (name_value, width, value, numeric, textAlign) => {
      return (
        <TableCell
          className={classes.noPadding}
          style={{
            width,
            borderTop: "1px solid #e0e0e0",
            backgroundColor: "rgba(0,0,0,0.02)",
            textAlign,
          }}
        >
          {numeric ? (
            <NumberFormat
              id={`ins.${index}.${name_value}`}
              autoComplete={"off"}
              value={roundBy(
                value,
                WBSPropertiesStore.getRules(
                  name_value === "unitCost" || name_value === "newCost"
                    ? undefined
                    : 2
                )
              )}
              className={classes.input}
              {...(i18n.language === "PT"
                ? { decimalSeparator: ",", thousandSeparator: "." }
                : { decimalSeparator: ".", thousandSeparator: "," })}
              fixedDecimalScale={true}
              decimalScale={
                name_value === "unitCost" || name_value === "newCost"
                  ? WBSStore.WBS.data.decimalPlaces
                  : 2
              }
              readOnly={true}
              style={{
                textAlign,
                caretColor: "transparent",
                fontWeight: name_value === "newCost" ? "bold" : "normal",
              }}
            />
          ) : (
            <input
              id={`ins.${index}.${name_value}`}
              value={value}
              className={classes.input}
              style={{
                textAlign,
                caretColor: "transparent",
              }}
            />
          )}
        </TableCell>
      );
    };
    const item = WBSStore.newCompositionList[index].old.data;

    var contentType = "";
    // “labor” - Quando for mão de obra
    // “equipment” - Quando for equipamento
    // “material” - Quando for material
    // “other” - Quando for outro.
    if (
      item.contentType === EContentType.LABOR ||
      item.contentType === EContentType.EQUIPMENT ||
      item.contentType === EContentType.MATERIAL
    ) {
      contentType = i18n.project.rightSideMenu.categories[item.contentType];
    } else {
      contentType = i18n.project.rightSideMenu.categories.other;
    }

    return (
      <div
        key={key}
        style={style}
        className={classes.hover}
        onClick={() => this.setState({ selectedLine: index })}
      >
        {/* 283 */}
        {tableCell(
          "rowCode",
          this.columnWidth(COLUMN_SIZE[0]),
          WBSStore.newCompositionList[index].new.data.code,
          false,
          "left"
        )}
        {tableCell(
          "description",
          this.columnWidth(COLUMN_SIZE[1]),
          item.description,
          false,
          "left"
        )}
        {tableCell(
          "unit",
          this.columnWidth(COLUMN_SIZE[2]),
          item.unit,
          false,
          "center"
        )}
        {tableCell(
          "unitCost",
          this.columnWidth(COLUMN_SIZE[3]),
          item.unitCost,
          true,
          "right"
        )}
        {tableCell(
          "newCost",
          this.columnWidth(COLUMN_SIZE[4]),
          WBSStore.newCompositionList[index].new.data.totalCost,
          true,
          "right"
        )}
        {tableCell(
          "contentType",
          this.columnWidth(COLUMN_SIZE[5]),
          contentType,
          false,
          "left"
        )}
      </div>
    );
  };
  render() {
    const { classes } = this.props;
    return (
      <>
        <List
          width={window.innerWidth - 290}
          height={50}
          rowCount={1}
          rowHeight={50}
          rowRenderer={this.headerRenderer}
          style={{ overflowY: "unset" }}
          overscanRowCount={0}
        />
        <List
          width={window.innerWidth - 290}
          height={window.innerHeight - 300}
          rowCount={WBSStore.newCompositionList.length}
          rowHeight={25}
          rowRenderer={this.cellRenderer}
          style={{ overflowY: "unset", fontSize: "13px", color: "#666" }}
          overscanRowCount={10}
        />
        <div className={classes.editFormatActions}>
          <Button
            variant="contained"
            color="primary"
            className={[classes.button, classes.buttonCancel].join(" ")}
            onClick={() => {
              WBSStore.newCompositionList = [];
              WBSStore.selectedComposition = {};
              TakeOffStore.swipeTabComposition = 0;
            }}
          >
            {i18n.cancel}
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={[classes.button, classes.buttonSave].join(" ")}
            onClick={this.handleClickSave}
          >
            {i18n.save}
          </Button>
        </div>
      </>
    );
  }
}
export default withStyles(styles)(UpdateBudgetResorcesTab2);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/UpdateBudgetResorcesTab2.tsx